import React from "react";
import { useTranslation } from "react-i18next";

import CustomModal from "../../packages/CustomModal";
import compassIcon from "../../assets/compass-icon.svg";
import deploymentUnitIcon from "../../assets/deployment-unit-icon.svg";
import CustomRadioCheck from "../../common/styles/components/checkboxs/CustomRadioCheck";

import "./SkipDialog.scss";

const SkipDialog = ({ onClose, CIPNeverShowAgain, onNeverShowAgainChange }) => {
  const { t } = useTranslation();

  return (
    <CustomModal
      header={t("CIPShutdownStrings.introTitle")}
      confirmBtn={t("ValueStrings.okay")}
      onModalClose={onClose}
      width="550px"
    
    >
      <div className="info-box">
        <span className="info-text">{t("CIPShutdownStrings.introInfoText")}</span>

        <div className="info-item">
          <img src={compassIcon} alt="compass-icon" />
          {t("CIPShutdownStrings.introAutoIdentification")}
        </div>

        <div className="info-item">
          <img src={deploymentUnitIcon} alt="deployment-unit-icon" />
          {t("CIPShutdownStrings.introMethods")}
        </div>

        <CustomRadioCheck
          id="cip-checkbox"
          label={t("CIPShutdownStrings.neverShowAgain")}
          checked={CIPNeverShowAgain}
          onChange={(event) => onNeverShowAgainChange(event.target.checked)}
          className="skip-dialog-checkbox"
        />
      </div>
    </CustomModal>
  );
};

export default SkipDialog;
